import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../../models/GenericTableViewModel";
import { removeClient } from "../../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { removeIndustry } from "../../../service/industryService";
import { RouteComponentProps } from "../../../models/RouteComponent";
import { rolesRemove, rolesUpdate } from "../../../service/rolesService";
import { useNavigate } from "react-router-dom";
import { removeDocument, updateDocument } from "../../../service/documentsService";
import DocumentsAdd from "../documents-Add";

export default function EquipmentDocumentsView(props: any) {

  const client_id = props?.session?.client_id;

  const navigate = useNavigate();

  const [selectedRole, setSelectedRole] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const dialog = useRef(null as any);

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS },
    'active': { value: true, matchMode: FilterMatchMode.CONTAINS },
    'required': { value: null, matchMode: FilterMatchMode.CONTAINS },
  }

  const queryParams = {
    'type': 'equipment'
  }


  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedRole);
    removeDocument(selectedRole.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setSelectedRole(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setSelectedRole(row.value);
    // setVisible(true);
    viewSelected(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setSelectedRole(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeDocument(selectedRole.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    props.toast.current.show({ severity: 'success', summary: 'Document Deleted Successfully', life: 3000 });
  }

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const viewSelected = (row: any) => {
    setVisible(true);
  }

  const changeStatusFunc = async (status: boolean) => {
    props.setGlobalLoader(true);
    const client = await updateDocument(selectedRole.id, { "active": status });
    props.setGlobalLoader(false);
    setReload(!reload);
    props.toast.current.show({ severity: 'success', summary: status ? 'Document Activated Successfully' : 'Document Deactivated Successfully', life: 3000 });
  }

  const disableConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to deactivate document?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(false)
    });
  }

  const activateConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to activate document?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => changeStatusFunc(true)
    });
  }


  const unableToEdit = (row: any) => {
    props.toast.current.show({
      severity: "warning",
      summary: "Unable To Edit Document",
      life: 3000,
    });
  };

  const contextItems = () => {
    let objArray = [];
    if (client_id === selectedRole?.client || !client_id) {
      objArray.push({
        label: "View / Edit",
        icon: "pi pi-fw pi-eye",
        command: viewSelected,
      });
      if (selectedRole?.active) {
        objArray.push({
          label: "Deactivate",
          icon: "pi pi-fw pi-times-circle",
          command: disableConfirm,
        });
      } else {
        objArray.push({
          label: "Activate",
          icon: "pi pi-fw pi-check-circle",
          command: activateConfirm,
        });
      }
      objArray.push({
        label: "Delete",
        icon: "pi pi-fw pi-trash",
        command: deleteConfirm,
      });
    } else {
      objArray.push({
        label: "System entry unable to edit",
        icon: "pi pi-fw pi-times-circle",
        command: unableToEdit,
      });
    }
    return objArray;
  };


  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'required',
      header: 'Required',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'equipment_type_list',
      header: 'Equipment Type',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'created_at',
      header: 'Created At',
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false
    },
  ];


  return (
    <React.Fragment>

      <GenericTableView reload={reload} baseFilters={baseFilter} queryParams={queryParams} url='document' columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedRole?.id ? 'Update Document' : 'Add Document'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <DocumentsAdd setGlobalLoader={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedRole?.id} record={selectedRole} setVisible={setVisible} toast={props.toast} doc_type="equipment" selectEquipment={true}/>
      </Dialog>

      <ConfirmDialog />


    </React.Fragment>
  );
}